import axios, { AxiosError } from "axios";

import { WorkGroup } from "@teamprevent/common/workGroup/model";

const buildUrl = () => "/api/workGroup";

const getAll = async () => {
    try {
        const response = await axios.get<WorkGroup[]>(`${buildUrl()}/getAll`);
        return response.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 404) {
            return null;
        }

        throw ex;
    }
};

export const workGroupApi = { getAll };
